// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VP213{height:100%}.RHMZ6{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"maxHeight": `VP213`,
	"maxWidth": `RHMZ6`
};
export default ___CSS_LOADER_EXPORT___;
